<template>
  <v-form ref="form">
    <div class="text_field__container">
      <v-text-field
          class="text__field"
          color="#3254B9"
          base-color="#313743"
          variant="outlined"
          :rules="[rules.not_null]"
          v-model="data.organization"
          :loading="loading"
          :error="hasError('updated_fields')"
          :error-messages="getError('updated_fields')"
      >
        <template v-slot:label>
          <div class="label__text">
            <span v-if="$vuetify.display.width > 768">Образовательная</span>
            <span v-else>Обр.</span>
            организация
          </div>
        </template>
      </v-text-field>
      <v-select
          class="text__field"
          color="#3254B9"
          base-color="#313743"
          variant="outlined"
          item-title="text"
          item-value="value"
          no-data-text="Нет подходящих данных"
          :items="getEducationLevel"
          :rules="[rules.not_null]"
          v-model="data.education_level"
          :loading="loading"
          :error="hasError('updated_fields')"
          :error-messages="getError('updated_fields')"
      >
        <template v-slot:label>
          <div class="label__text">
            Уровень образования
          </div>
        </template>
      </v-select>
  <!--    <loading-autocomplete-->
  <!--        item-class="text__field custom__autocomplete"-->
  <!--        color="#3254B9"-->
  <!--        base-color="#313743"-->
  <!--        variant="outlined"-->
  <!--        v-model="data.education_direction"-->
  <!--        :loading="loading"-->
  <!--        :error="hasError('education_direction')"-->
  <!--        :error-messages="getError('education_direction')"-->
  <!--        item-title="text"-->
  <!--        item-value="value"-->
  <!--        :return-object="true"-->
  <!--        search-parameter="search"-->
  <!--        :url="education_direction_selector"-->
  <!--        :menu-props="{ maxWidth: $vuetify.display.width >= 1280 ? 500 : 270 }"-->
  <!--    >-->
  <!--      <template v-slot:label>-->
  <!--        <div class="label__text">-->
  <!--          <span v-if="$vuetify.display.width > 768">Направление</span>-->
  <!--          <span v-else>Напр.</span>-->
  <!--           подготовки-->
  <!--        </div>-->
  <!--      </template>-->
  <!--      <template v-slot:no-data>-->
  <!--        <div>-->
  <!--          Для поиска начните набирать название<span v-if="$vuetify.display.width >= 1280">, <br> и/или либо остановитесь на 1 секунду, либо нажмите Enter</span>-->
  <!--        </div>-->
  <!--      </template>-->
  <!--    </loading-autocomplete>-->
  <!--    <v-text-field-->
  <!--        class="text__field"-->
  <!--        color="#3254B9"-->
  <!--        base-color="#313743"-->
  <!--        variant="outlined"-->
  <!--        v-model="data.education_profile"-->
  <!--        :loading="loading"-->
  <!--        :error="hasError('education_profile')"-->
  <!--        :error-messages="getError('education_profile')"-->
  <!--    >-->
  <!--      <template v-slot:label>-->
  <!--        <div class="label__text">-->
  <!--          Профиль подготовки-->
  <!--        </div>-->
  <!--      </template>-->
  <!--    </v-text-field>-->
  <!--    <loading-autocomplete-->
  <!--        item-class="text__field custom__autocomplete"-->
  <!--        color="#3254B9"-->
  <!--        base-color="#313743"-->
  <!--        variant="outlined"-->
  <!--        v-model="data.education_profile"-->
  <!--        :loading="loading"-->
  <!--        :error="hasError('education_profile')"-->
  <!--        :error-messages="getError('education_profile')"-->
  <!--        item-title="text"-->
  <!--        item-value="value"-->
  <!--        :return-object="true"-->
  <!--        search-parameter="search"-->
  <!--        :url="education_profile_selector"-->
  <!--        :menu-props="{ maxWidth: $vuetify.display.width >= 1280 ? 500 : 270 }"-->
  <!--    >-->
  <!--      <template v-slot:label>-->
  <!--        <div class="label__text">-->
  <!--          Профиль подготовки-->
  <!--        </div>-->
  <!--      </template>-->
  <!--      <template v-slot:no-data>-->
  <!--        <div>-->
  <!--          Для поиска начните набирать название<span v-if="$vuetify.display.width >= 1280">, <br> и/или либо остановитесь на 1 секунду, либо нажмите Enter</span>-->
  <!--        </div>-->
  <!--      </template>-->
  <!--    </loading-autocomplete>-->
      <v-select
          class="text__field"
          color="#3254B9"
          base-color="#313743"
          variant="outlined"
          item-title="text"
          item-value="value"
          no-data-text="Нет подходящих данных"
          :rules="[rules.not_null]"
          :items="student_course"
          v-model="data.course"
          :loading="loading"
          :error="hasError('course')"
          :error-messages="getError('course')"
      >
        <template v-slot:label>
          <div class="label__text">
            Курс
          </div>
        </template>
      </v-select>
      <v-select
          class="text__field"
          color="#3254B9"
          base-color="#313743"
          variant="outlined"
          item-title="text"
          item-value="value"
          no-data-text="Нет подходящих данных"
          :rules="data.is_community_member ? [] : [rules.not_null]"
          :items="selectors.olympiads"
          v-model="data.olympiad"
          :loading="loading"
          :disabled="data.is_community_member"
          :error="hasError('olympiad')"
          :error-messages="getError('olympiad')"
      >
        <template v-slot:label>
          <div class="label__text">
            Олимпиада/Грант
          </div>
        </template>
      </v-select>
      <div class="check_box__container">
        <v-checkbox
            false-icon="$custom_checkbox"
            class="check__box"
            color="#3254B9"
            v-model="data.is_community_member"
            :loading="loading"
            :disabled="data.is_grant_holder"
            :error="hasError('is_community_member')"
            :error-messages="getError('is_community_member')"
        >
          <template v-slot:label>
            <div class="check__box_text">
              Представитель СНО
            </div>
          </template>
        </v-checkbox>
        <v-checkbox
            false-icon="$custom_checkbox"
            class="check__box"
            color="#3254B9"
            v-model="data.is_grant_holder"
            :loading="loading"
            :disabled="data.is_community_member"
            :error="hasError('is_grant_holder')"
            :error-messages="getError('is_grant_holder')"
        >
          <template v-slot:label>
            <div class="check__box_text">
              Обладатель гранта/именной стипендии
            </div>
          </template>
        </v-checkbox>
        <v-checkbox
            false-icon="$custom_checkbox"
            class="check__box"
            color="#3254B9"
            v-model="data.is_winner"
            :loading="loading"
            :disabled="data.is_community_member || data.is_grant_holder"
            :error="hasError('is_winner')"
            :error-messages="getError('is_winner')"
        >
          <template v-slot:label>
            <div class="check__box_text">
              Являюсь победителем
            </div>
          </template>
        </v-checkbox>
        <v-checkbox
            false-icon="$custom_checkbox"
            class="check__box"
            color="#3254B9"
            v-model="data.is_prizewinner"
            :loading="loading"
            :disabled="data.is_community_member || data.is_grant_holder"
            :error="hasError('is_prizewinner')"
            :error-messages="getError('is_prizewinner')"
        >
          <template v-slot:label>
            <div class="check__box_text">
              Являюсь призером
            </div>
          </template>
        </v-checkbox>
      </div>
    </div>
    <div class="page__subtitle mt-4">
      Приложите подтверждающие документы
    </div>
    <v-alert class="file__container mb-10" type="info" rounded="lg" max-width="900" color="#376FFE" :closable="true" variant="outlined" :icon="false">
      Требования к загружаемым файлам: не менее 200dpi, не более 5 Мбайт
    </v-alert>
    <div class="page__sub_subtitle">
      Прикрепите 2-3 страницу (разворот с фотографией и ФИО) документа, удостоверяющего вашу личность
    </div>
    <div class="file__container">
      <v-file-input
          class="file__input"
          label="File input"
          variant="outlined"
          prepend-icon=""
          color="#3254B9"
          base-color="#313743"
          accept=".pdf, image/png, image/jpeg"
          :show-size="1000"
          :rules="[rules.file]"
          v-model="data.file1"
          :loading="loading"
          :error="hasError('files')"
          :error-messages="getError('files')"
      >
        <template v-slot:label>
          <div class="d-flex flex-wrap">
            <v-row justify="center" class="file__input_row" no-gutters>
              <v-icon :size="$vuetify.display.width >= 1280 ? 112 : 56">$custom_clip</v-icon>
            </v-row>
            <v-row justify="center" class="file__input_row" no-gutters>
              <div class="file_label__text">
                Выберите файл<span v-if="$vuetify.display.width >= 1280">(.pdf, .png или .jpeg) или перетащите его сюда</span>
              </div>
            </v-row>
          </div>
        </template>
      </v-file-input>
      <div class="page__sub_subtitle">
        <span v-if="data.is_community_member">
          Справка, подтверждающая принадлежность к СНО
        </span>
        <span v-else-if="data.is_grant_holder">
          Справка из образовательной организации о получении именной стипендии/гранта
        </span>
        <span v-else>
          Справка из образовательной организации
        </span>
      </div>
      <v-file-input
          class="file__input"
          label="File input"
          variant="outlined"
          prepend-icon=""
          color="#3254B9"
          base-color="#313743"
          accept=".pdf, image/png, image/jpeg"
          :show-size="1000"
          :rules="[rules.file]"
          v-model="data.file2"
          :loading="loading"
          :error="hasError('files')"
          :error-messages="getError('files')"
      >
        <template v-slot:label>
          <div class="d-flex flex-wrap">
            <v-row justify="center" class="file__input_row" no-gutters>
              <v-icon :size="$vuetify.display.width >= 1280 ? 112 : 56">$custom_clip</v-icon>
            </v-row>
            <v-row justify="center" class="file__input_row" no-gutters>
              <div class="file_label__text">
                Выберите файл<span v-if="$vuetify.display.width >= 1280">(.pdf, .png или .jpeg) или перетащите его сюда</span>
              </div>
            </v-row>
          </div>
        </template>
      </v-file-input>
      <div class="page__sub_subtitle" v-if="!data.is_community_member && !data.is_grant_holder">
        Диплом победителя или призёра соответствующей олимпиады
      </div>
      <v-file-input
          v-if="!data.is_community_member && !data.is_grant_holder"
          class="file__input"
          label="File input"
          variant="outlined"
          prepend-icon=""
          color="#3254B9"
          base-color="#313743"
          accept=".pdf, image/png, image/jpeg"
          :show-size="1000"
          :rules="[rules.file]"
          v-model="data.file3"
          :loading="loading"
          :error="hasError('files')"
          :error-messages="getError('files')"
      >
        <template v-slot:label>
          <div class="d-flex flex-wrap">
            <v-row justify="center" class="file__input_row" no-gutters>
              <v-icon :size="$vuetify.display.width >= 1280 ? 112 : 56">$custom_clip</v-icon>
            </v-row>
            <v-row justify="center" class="file__input_row" no-gutters>
              <div class="file_label__text">
                Выберите файл<span v-if="$vuetify.display.width >= 1280">(.pdf, .png или .jpeg) или перетащите его сюда</span>
              </div>
            </v-row>
          </div>
        </template>
      </v-file-input>
    </div>
  </v-form>
  <div class="alert__container" v-if="error">
    <v-alert
        class="error_alert"
        :value="true"
        outline
        :icon="false"
        color="#8f0808"
        variant="outlined"
    >
      {{ error[0] }}
    </v-alert>
  </div>
  <v-btn
      class="btn__next"
      elevation="0"
      :loading="loading"
      @click="validate"
  >
    <span class="btn__next_text">
      ДАЛЕЕ
    </span>
  </v-btn>
</template>

<script>
import { defineComponent } from 'vue'
import names from "@/modules/core/routers/names"
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import pa_names from "@/modules/personal_account/routers/names"
import { mapActions, mapGetters, mapMutations } from "vuex"
// import LoadingAutocomplete from "@/modules/templates/LoadingAutocomplete.vue"
// import selectors from "@/urls/selectors"

export default defineComponent({
  name: "IndividualInfoStudent",
  mixins: [FormErrorsMixin],
  // components: {
  //   LoadingAutocomplete
  // },
  data () {
    return {
      data: {
        organization: '',
        education_level: null,
        // education_direction: null,
        // education_profile: null,
        olympiad: null,
        course: null,
        is_two_profiles: false,
        is_community_member: false,
        is_grant_holder: false,
        is_winner: false,
        is_prizewinner: false,
        file1: undefined,
        file2: undefined,
        file3: undefined,
      },
      loading: false,
      type_date: false,
      error: null,
      selectors: {
        olympiads: [],
      },
      rules: {
        number: value => {
          if (value !== '') {
            const pattern = /^\d{1}$/
            return pattern.test(value) || 'Некорректный ввод'
          } else {
            return 'Обязательное поле'
          }
        },
        not_null: value => {
          if (value !== undefined && value !== null) {
            if (typeof value === "string") {
              return value.trim().length > 0 || 'Поле не может быть пустым'
            } else {
              return value || 'Поле не может быть пустым'
            }
          } else {
            return 'Обязательное поле'
          }
        },
        file: value => {
          if (value !== undefined && value !== null && value.length > 0) {
            return !value || !value.length || value[0].size < 5000000 || 'Файл больше 5 мб.'
          } else {
            return 'Обязательное поле'
          }
        },
      }
    }
  },
  watch: {
    data: {
      handler: function () {
        this.errors = {
          fields: {},
          non: []
        }
        this.error = null
      },
      deep: true
    },
    'data.education_level': {
      handler: function () {
        this.data.olympiad = null
        this.loadSelectors(this.data.education_level, this.data.is_grant_holder)
      },
      deep: true
    },
    'data.is_community_member' () {
      this.data.olympiad = null
      this.data.is_winner = false
      this.data.is_prizewinner = false
      this.data.is_grant_holder = false
      this.data.file3 = undefined
    },
    'data.is_grant_holder' () {
      this.data.olympiad = null
      this.loadSelectors(this.data.education_level, this.data.is_grant_holder)
      this.data.is_winner = false
      this.data.is_prizewinner = false
      this.data.is_community_member = false
      this.data.file3 = undefined
    }
  },
  computed: {
    pa_names () {
      return pa_names
    },
    names () {
      return names
    },
    student_course () {
      const courses = [
        {
          value: 1,
          text: 1
        },
        {
          value: 2,
          text: 2
        },
        {
          value: 3,
          text: 3
        },
        {
          value: 4,
          text: 4
        },
        {
          value: 5,
          text: 5
        },
        {
          value: 6,
          text: 6
        }
      ]
      if (this.data.education_level) {
        if (this.data.education_level === 'Бакалавриат') {
          return courses.splice(0, 4)
        } else if (this.data.education_level === 'Бакалавриат (с двумя профилями)') {
          return courses.splice(0, 5)
        } else if (this.data.education_level === 'Магистратура') {
          return courses.splice(0, 2)
        } else if (this.data.education_level === 'Специалитет') {
          return courses
        } else if (this.data.education_level === 'Среднее профессиональное образование') {
          return courses.splice(0, 4)
        } else {
          return courses
        }
      } else {
        return courses
      }
    },
    // education_direction_selector () {
    //   return selectors.SELECTORS.EDUCATION_DIRECTION()
    // },
    // education_profile_selector () {
    //   return selectors.SELECTORS.EDUCATION_PROFILE()
    // },
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      getUserStatus: 'auth/getUserStatus',
      getEducationLevel: 'choices/getEducationLevel',
      getPreviousMembers: 'personal_account/members/getPreviousMembers'
    })
  },
  methods: {
    ...mapActions({
      memberApplicationUpdate: 'personal_account/members/memberApplicationUpdate',
      loadEducationLevel: 'choices/loadEducationLevel',
      loadOlympiads: 'selectors/loadOlympiads',
      loadPreviousMembers: 'personal_account/members/loadPreviousMembers',
    }),
    ...mapMutations({
      SET_EDUCATION_LEVEL: "choices/SET_EDUCATION_LEVEL"
    }),
    endRedirect () {
      if (window.scrollY !== 0) {
        window.scroll({
          top: 0,
          behavior: 'smooth'
        })
      }
      this.$router.push({ name: pa_names.MAIN })
    },
    loadChoices () {
      this.loadEducationLevel({
        url: undefined,
        finalizer: (data) => {
          data.splice(1, 0, { value: "Бакалавриат (с двумя профилями)", text: "Бакалавриат (с двумя профилями)" })
          this.SET_EDUCATION_LEVEL(data)
        },
      })
    },
    loadSelectors (level = 'Бакалавриат', is_grant = false) {
      this.loadOlympiads({
        url: undefined,
        params: { level: level, is_grant: is_grant },
        finalizer: (val) => {
          this.selectors.olympiads = val
        }
      })
    },
    loadData (url = undefined) {
      this.loadPreviousMembers({
        url: url,
        finalizer: (data) => {
          this.putDataInFields(data)
        },
        catcher: () => {
          this.$router.push({ name: names.REGISTRATION.PAGE })
        }
      })
    },
    putDataInFields (data) {
      if (data?.member_request === undefined || data?.member_request === null) {
        return null
      }
      if (data.member_request.type === "student") {
        for (const key of Object.keys(data.member_request)) {
          // eslint-disable-next-line
          if (this.data.hasOwnProperty(key)) {
            if (key === 'olympiad') {
              this.data.olympiad = data.member_request.olympiad.id
            } else {
              this.data[key] = data.member_request[key]
            }
          }
        }
      }
    },
    async validate () {
      const { valid } = await this.$refs.form.validate()

      if (valid) {
        this.sendCreateStudent()
      }
    },
    sendCreateStudent: function () {
      this.loading = true
      this.error = null
      // if (this.data.education_direction) { this.data.education_direction = this.data.education_direction.value }
      // if (this.data.education_profile) { this.data.education_profile = this.data.education_profile.value }
      if (this.data.education_level === 'Бакалавриат (с двумя профилями)') {
        this.data.education_level = 'Бакалавриат'
        this.data.is_two_profiles = true
      }

      const formData = new FormData()
      const updated_fields = {}

      for (const key of Object.keys(this.data)) {
        if (key === "file1") {
          if (this.data[key]) {
            formData.append('files', this.data[key][0], this.data[key][0].name)
            formData.append('names', `Паспорт_${this.data[key][0].name}`)
            formData.append('types', 'Паспорт')
          }
        } else if (key === "file2") {
          if (this.data[key]) {
            formData.append('files', this.data[key][0], this.data[key][0].name)
            formData.append('names', `Справка_${this.data[key][0].name}`)
            formData.append('types', 'Справка')
          }
        } else if (key === "file3") {
          if (this.data[key]) {
            formData.append('files', this.data[key][0], this.data[key][0].name)
            formData.append('names', `Диплом_${this.data[key][0].name}`)
            formData.append('types', 'Диплом')
          }
        } else {
          if (this.data[key]) {
            updated_fields[key] = this.data[key]
          }
        }
      }

      if (Object.keys(updated_fields).length > 0) {
        formData.append('updated_fields', JSON.stringify(updated_fields))
      }

      this.memberApplicationUpdate(
        {
          data: formData,
          finalizer: () => {
            this.loading = false
            this.error = null
            this.endRedirect()
          },
          catcher: (error) => {
            if (this.data.is_two_profiles === true) {
              this.data.education_level = 'Бакалавриат (с двумя профилями)'
              this.data.is_two_profiles = false
            }
            this.loading = false
            if (error.member) {
              this.error = error.member
            } else if (error.detail) {
              this.error = error.detail
            } else if (error.files === "Ensure this field has at least 2 elements.") {
              error.files = 'Вы прикрепили не все требуемые файлы.'
              this.mapErrors(error)
            } else {
              this.mapErrors(error)
            }
          }
        }
      )
    },
  },
  created () {
    if (this.getUserStatus.special_information) {
      this.$router.push({ name: pa_names.MAIN })
    }
    if (this.getUserStatus.has_previous) {
      if (this.getPreviousMembers === null) {
        this.loadData()
      } else {
        this.putDataInFields(this.getPreviousMembers)
      }
    }
    if (this.getEducationLevel.length === 0 || this.selectors.olympiads.length === 0) {
      this.loadChoices()
      this.loadSelectors()
    }
  },
})
</script>

<style scoped lang="scss">
.page__subtitle {
  margin-bottom: 50px;
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 51px;
  text-align: center;

  color: #313743;
}

.page__sub_subtitle {
  margin-bottom: 30px;
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 35px;
  text-align: center;

  color: #3254B9;
}

.text_field__container {
  margin: 0 auto;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  width: 500px;
}

.btn__next {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-self: end;
  margin-bottom: 50px;
  width: 200px;
  height: 80px;
  border: 2px solid #3254B9;
  background-color: #3254B9;
  border-radius: 10px;

  &:hover {
    background-color: transparent;

    .btn__next_text {
      color: #3254B9;
    }
  }
}

.btn__next_text {
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #FFFFFF;
}

.text__field {
  margin: 0 auto 20px;
  width: 100%;
}

.v-field__field:hover {
  .label__text {
    color: black;
  }
}

.label__text {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  text-align: center;

  color: #313743;
}

.file__container {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 1440px;
}

.file__input {
  margin: 0 auto 40px;
  width: 100%;
}

.file_label__text {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  text-align: center;

  color: #313743;
}

.file__input_row {
  width: 100%;

  &:first-child {
    margin-bottom: 30px;
  }
}

.file__container > .v-input--density-default {
  --v-input-control-height: 300px;
}

.file__container > .v-input > .v-input__control > .v-field--active {
  .file__input_row {
    &:first-child {
      display: none;
    }
  }

  .file_label__text {
    color: currentColor;
  }
}

.check_box__container {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
}

.check__box {
  margin: -10px 0 -10px 0px;
  width: 100%;
  color: #313743;
}

.check__box_text {
  padding-left: 30px;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  display: inline-block;
  align-items: center;
  text-align: left;
  color: #313743;
}

.alert__container {
  justify-content: center;
  align-items: center;
  margin: 0 auto 10px;
  width: 100%;
  max-width: 500px;
}

.error_alert {
  border-radius: 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 21px;
  color: #8f0808;
  margin-bottom: 20px;
}

@media screen and (max-width: 1920px) {
  .page__subtitle {
    margin-bottom: 40px;
    font-size: 30px;
    line-height: 41px;
  }

  .text__field {
    margin-bottom: 10px;
  }

  .btn__next {
    height: 70px;
  }
}

@media screen and (max-width: 1440px) {
  .file__container {
    width: 1200px;
  }
}

@media screen and (max-width: 1279px) {
  .page__subtitle {
    font-size: 24px;
    line-height: 31px;
    padding: 0 40px;
  }

  .page__sub_subtitle {
    font-size: 20px;
    line-height: 27px;
    padding: 0 20px;
  }

  .file__container {
    width: 600px;
  }
}

@media screen and (max-width: 768px) {
  .page__subtitle {
    margin-bottom: 40px;
    font-size: 18px;
    line-height: 22px;
    padding: 0 20px;
  }

  .page__sub_subtitle {
    margin-bottom: 20px;
    font-size: 16px;
    line-height: 19px;
  }

  .text_field__container {
    width: 400px;
  }

  .label__text {
    font-size: 16px;
    line-height: 20px;
  }

  .btn__next {
    height: 55px;
    margin-bottom: 20px;
  }

  .btn__next_text {
    font-size: 16px;
    line-height: 20px;
  }

  .file__container {
    width: 500px;
  }

  .check__box_text {
    padding-left: 10px;
    font-size: 16px;
    line-height: 20px;
  }

  .file_label__text {
    font-size: 16px;
    line-height: 20px;
  }

  .file__container > .v-input--density-default {
    --v-input-control-height: 200px;
  }
}

@media screen and (max-width: 600px) {
  .text_field__container {
    width: 270px;
  }

  .text__field {
    margin-bottom: 8px;
  }

  .check__box {
    margin: -5px 0 -10px 0px;
  }

  .file__container {
    width: 300px;
  }
}

@media screen and (max-width: 300px) {
  .file__container {
    width: 270px;
  }
}
</style>
